import React from "react";
import { Route, Routes } from "react-router-dom";
import TextureGroup from "../layout/textureGroup/TextureGroup";
import AddTextureGroup from "../layout/textureGroup/AddTextureGroup";
const TextureGroupPage = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<TextureGroup />} />
        <Route path="/add" element={<AddTextureGroup />} />
        <Route path="/update/:id" element={<AddTextureGroup />} />
      </Routes>
    </>
  );
};

export default TextureGroupPage;
